var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJoinigUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3543 4.6875C8.53532 4.6875 6.25011 6.97271 6.25011 9.79167C6.25011 12.6106 8.53532 14.8958 11.3543 14.8958C14.1732 14.8958 16.4584 12.6106 16.4584 9.79167C16.4584 6.97271 14.1732 4.6875 11.3543 4.6875ZM8.12511 9.79167C8.12511 8.00825 9.57085 6.5625 11.3543 6.5625C13.1377 6.5625 14.5834 8.00825 14.5834 9.79167C14.5834 11.5751 13.1377 13.0208 11.3543 13.0208C9.57085 13.0208 8.12511 11.5751 8.12511 9.79167Z",
    fill: "#121212"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70841 17.1875C6.3547 17.1875 5.05644 17.7253 4.09922 18.6825C3.14201 19.6397 2.60425 20.938 2.60425 22.2917V24.375C2.60425 24.8928 3.02398 25.3125 3.54175 25.3125C4.05951 25.3125 4.47925 24.8928 4.47925 24.375V22.2917C4.47925 21.4352 4.81946 20.6139 5.42505 20.0083C6.03064 19.4027 6.85199 19.0625 7.70841 19.0625H15.0001C15.8565 19.0625 16.6779 19.4027 17.2834 20.0083C17.889 20.6139 18.2292 21.4352 18.2292 22.2917V24.375C18.2292 24.8928 18.649 25.3125 19.1667 25.3125C19.6845 25.3125 20.1042 24.8928 20.1042 24.375V22.2917C20.1042 20.938 19.5665 19.6397 18.6093 18.6825C17.6521 17.7253 16.3538 17.1875 15.0001 17.1875H7.70841Z",
    fill: "#121212"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3335 9.89624C23.8512 9.89624 24.271 10.316 24.271 10.8337V13.0212H26.4585C26.9762 13.0212 27.396 13.441 27.396 13.9587C27.396 14.4765 26.9762 14.8962 26.4585 14.8962H24.271V17.0837C24.271 17.6015 23.8512 18.0212 23.3335 18.0212C22.8157 18.0212 22.396 17.6015 22.396 17.0837V14.8962H20.2085C19.6907 14.8962 19.271 14.4765 19.271 13.9587C19.271 13.441 19.6907 13.0212 20.2085 13.0212H22.396V10.8337C22.396 10.316 22.8157 9.89624 23.3335 9.89624Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoinigUser);
export default __webpack_public_path__ + "static/media/joinig-user.1e8bdb64a77a9e6d4984093648db2edf.svg";
export { ForwardRef as ReactComponent };